export default __webpack_public_path__ + "static/media/1.ed7aa8f3.jpeg";